const CONTEXT_API = 'Context API';
const CATEGORY_STUDY_PT = 'Estudos (Trybe)';
const CATEGORY_STUDY_EN = 'Studies (Trybe)';

const translations = {
  en: {
    title: 'Projects',
    subTitle: 'SaaS plus study repos from Trybe',
    openApp: 'Open app',
    openSite: 'Open site',
    viewCode: 'Source code',
    featuredLabel: 'Highlights',
    studyLabel: 'Practice & coursework',
  },
  pt: {
    title: 'Projetos',
    subTitle: 'SaaS de finanças e outros estudos',
    openApp: 'Abrir aplicativo',
    openSite: 'Abrir site',
    viewCode: 'Ver código',
    featuredLabel: 'Destaques',
    studyLabel: 'Prática e estudos',
  },
  projects: [
    {
      layout: 'showcase',
      image: '/sabio-financeiro-dashboard.png',
      imageAltPT: 'Captura da interface do Sábio Financeiro',
      imageAltEN: 'Sábio Financeiro product screenshot',
      title: 'Sábio Financeiro',
      categoryPT: 'Produto · SaaS',
      categoryEN: 'Product · SaaS',
      site: 'https://app.sabiofinanceiro.com.br/',
      siteCta: 'app',
      technologies: [
        'Next.js',
        'NestJS',
        'TypeScript',
        'Prisma',
        'PostgreSQL',
        'Docker',
      ],
      synopsisPT:
        'SaaS de finanças pessoais: lançamentos, categorias, parcelas e relatórios. Stack Next.js, NestJS, Prisma e PostgreSQL; deploy com Docker.',
      synopsisEN:
        'Personal finance SaaS: entries, categories, installments, reports. Next.js, NestJS, Prisma, PostgreSQL; shipped with Docker.',
    },
    {
      layout: 'card',
      image: '/trybe_football.jpg',
      imageAltPT: 'Captura do projeto Football Club',
      imageAltEN: 'Football Club project screenshot',
      title: 'Football Club',
      categoryPT: CATEGORY_STUDY_PT,
      categoryEN: CATEGORY_STUDY_EN,
      github: 'https://github.com/feroddev/footballclub',
      technologies: [
        'Node.js',
        'Express',
        'MySQL',
        'Sequelize',
        'TypeScript',
        'Docker',
        'REST API',
        'JWT',
      ],
      synopsisPT:
        'API REST com JWT; modela times, partidas e classificação em MySQL com Sequelize. Projeto de módulo backend na Trybe.',
      synopsisEN:
        'REST API with JWT; teams, matches, standings in MySQL via Sequelize. Trybe backend module project.',
    },
    {
      layout: 'card',
      image: '/blog_api.jpg',
      imageAltPT: 'Captura do projeto Blogs API',
      imageAltEN: 'Blogs API project screenshot',
      title: 'Blogs API',
      categoryPT: CATEGORY_STUDY_PT,
      categoryEN: CATEGORY_STUDY_EN,
      github: 'https://github.com/feroddev/blogs-api',
      technologies: [
        'Node.js',
        'Express',
        'MySQL',
        'Sequelize',
        'JWT',
        'Docker',
        'REST API',
      ],
      synopsisPT:
        'Blog com usuários e posts relacionados; autenticação JWT e camadas separadas (controller/service/model).',
      synopsisEN:
        'Blog with users and linked posts; JWT auth and split controller/service/model layers.',
    },
    {
      layout: 'card',
      image: '/trybetunes.jpg',
      imageAltPT: 'Captura do projeto TrybeTunes',
      imageAltEN: 'TrybeTunes project screenshot',
      title: 'TrybeTunes',
      categoryPT: CATEGORY_STUDY_PT,
      categoryEN: CATEGORY_STUDY_EN,
      github: 'https://github.com/feroddev/trybetunes',
      site: 'https://trybetunes-sandy.vercel.app/',
      technologies: [
        'React',
        'Redux',
        'Bootstrap',
        CONTEXT_API,
        'Hooks',
        'RTL',
      ],
      synopsisPT:
        'SPA de música: busca na API do iTunes, favoritos em Redux e testes com RTL. Frontend da formação Trybe.',
      synopsisEN:
        'Music SPA: iTunes search, favorites in Redux, RTL tests. Trybe frontend coursework.',
    },
    {
      layout: 'card',
      image: '/notable_news.jpg',
      imageAltPT: 'Captura do projeto Notable News',
      imageAltEN: 'Notable News project screenshot',
      title: 'Notable News',
      categoryPT: CATEGORY_STUDY_PT,
      categoryEN: CATEGORY_STUDY_EN,
      github: 'https://github.com/feroddev/projeto-noticias-notaveis',
      site: 'https://projeto-noticias-notaveis.vercel.app/',
      technologies: [
        'React',
        'Hooks',
        CONTEXT_API,
        'RTL',
        'TypeScript',
      ],
      synopsisPT:
        'Lista notícias de API externa em TypeScript; loading e erro explícitos na UI; testes com RTL.',
      synopsisEN:
        'News list from an external API in TypeScript; explicit loading/error UI; RTL tests.',
    },
  ],
};

export default translations;
